export default __webpack_public_path__ + "28fc9ad8b008a35f5fdfe684aea445e2.png";